import { MutableRefObject, useCallback, useEffect, useRef } from "react";
import {
  CANVAS_HEIGHT,
  CANVAS_WIDTH,
  normalizeToIFrameCoordinates,
} from "../utils";
import { useCanvasStore } from "@/store/zustand/canvasStore";
import _ from "lodash";
import { useUpdateMyPresence } from "../../../../liveblocks.config";

export const useOnMouseMove = (
  canvasRef: MutableRefObject<any>,
  iframesRef: MutableRefObject<{ [storyboardId: string]: any }>
) => {
  const setCanvasMousePos = useCanvasStore((store) => store.setCanvasMousePos);
  const setIframeMousePos = useCanvasStore((store) => store.setIframeMousePos);
  const setMouseOverStoryboardId = useCanvasStore(
    (store) => store.setMouseOverStoryboardId
  );

  const updateMyPresence = useUpdateMyPresence();
  const updateMyPresenceRef = useRef(updateMyPresence);

  useEffect(() => {
    updateMyPresenceRef.current = updateMyPresence;
  }, [updateMyPresence]);

  const onMouseMove = useCallback((e: any, storyboardId: string) => {
    // @ts-ignore
    const canvasBoundingRect = canvasRef?.current?.getBoundingClientRect();

    if (!canvasBoundingRect) {
      return;
    }

    const { x, y, clientX, clientY } = e;

    // Resolve the coordinates to the iframe container if necessary
    let iframeX = clientX;
    let iframeY = clientY;

    if (storyboardId) {
      const { x: resolvedX, y: resolvedY } = normalizeToIFrameCoordinates(
        iframesRef,
        clientX,
        clientY,
        storyboardId
      );

      iframeX = resolvedX;
      iframeY = resolvedY;
    }

    // Resolve iframe coordinates to canvas coordinates

    const canvasX =
      ((iframeX - canvasBoundingRect.left) / canvasBoundingRect.width) *
        CANVAS_WIDTH -
      CANVAS_WIDTH / 2;
    const canvasY =
      ((iframeY - canvasBoundingRect.top) / canvasBoundingRect.height) *
        CANVAS_HEIGHT -
      CANVAS_HEIGHT / 2;

    setCanvasMousePos(Math.round(canvasX), Math.round(canvasY));

    updateMyPresenceRef.current({
      cursor: {
        x: Math.round(canvasX),
        y: Math.round(canvasY),
      },
    });

    if (storyboardId) {
      setIframeMousePos(e);
      setMouseOverStoryboardId(storyboardId);
    }
  }, []);

  const throttledMouseMoveRef = useRef(
    _.throttle(onMouseMove, 25, { leading: true, trailing: true })
  );

  useEffect(() => {
    throttledMouseMoveRef.current = _.throttle(onMouseMove, 25, {
      leading: true,
      trailing: true,
    });
  }, []);

  return throttledMouseMoveRef.current;
};
